export const EXPORT_PDF = 'pdf' as const;
export const EXPORT_CSV = 'csv' as const;

export type ExportFormat = typeof EXPORT_PDF | typeof EXPORT_CSV;
